import React, { useEffect, createContext, useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getLevels } from "../../constants/constant-role";
import { getLevelsID } from "../../constants/constant-role-id";

import {
  updateUserDetailsAction,
  updateSelectedBsaAction,
  updateLevelAction,
  updateSelectedCountryCodeAction,
  updateDTAccessAction,
  updateAdminAccessAction,
  updateUcubeAccessAction,
  updateOpsReportAccessAction,
} from "./Actions/StoreActions";
import { getLevelsBD } from "../../constants/constant-role-bd";

const StoreContext = createContext("");

let StoreContextProvider = props => {
  const {
    userDetails,
    updateUserDetails,
    updateSelectedBsa,
    selectedBsa,
    updateCountryCode,
    selectedCountryCode,
    updateLevel,
    level,
    dtAccess,
    updateDTAccess,
    updateAdminAccess,
    adminAccess,
    updateUcubeAccess,
    ucubeAccess,
    updateOpsReportAccess,
    opsReportAccess
  } = props;
  const value = useMemo(
    () => ({
      userDetails,
      updateUserDetails,
      updateSelectedBsa,
      selectedBsa,
      updateLevel,
      updateCountryCode,
      selectedCountryCode,
      level,
      dtAccess,
      updateDTAccess,
      updateAdminAccess,
      adminAccess,
      updateUcubeAccess,
      ucubeAccess,
      updateOpsReportAccess,
      opsReportAccess,
    }),
    [
      userDetails,
      updateUserDetails,
      updateSelectedBsa,
      selectedBsa,
      updateLevel,
      updateCountryCode,
      selectedCountryCode,
      level,
      dtAccess,
      updateDTAccess,
      updateAdminAccess,
      adminAccess,
      updateUcubeAccess,
      ucubeAccess,
      updateOpsReportAccess,
      opsReportAccess,
    ]
  );
  const sortArray = bsa => {
    const dummy = selectedCountryCode === "idic"  ? ["Ice Cream", "Distributor", "New Channel"] : ["Distributor", "New Channel", "Ice Cream"];
    const sortedArray = bsa.slice().sort((a, b) =>
      dummy.indexOf(a) - dummy.indexOf(b))
    return sortedArray;
  };
  const countryFunction = countries => {
    if (countries.length > 0) {
      for (const country of countries) {
        switch (country) {
          case "id":
            localStorage.setItem("isIndonesia", true);
            break;
          case "vn":
            localStorage.setItem("isVietnam", true);
            break;
          case "ph":
            localStorage.setItem("isPhilipines", true);
            break;
          case "th":
            localStorage.setItem("isThailand", true);
            break;
          case "pk":
            localStorage.setItem("isPakistan", true);
            break;
          case "bd":
            localStorage.setItem("isBangladesh", true);
            break;
          case "idic":
            localStorage.setItem("isIndonesiaIc", true);
            break;
            case "kh":
            localStorage.setItem("isCambodia", true);
            break;
            case "la":
            localStorage.setItem("isLaos", true);
            break;
          default:
            break;
        }
      }
    }
  };
  useEffect(() => {
    const bsa = userDetails?.bsa || [];
    const role = userDetails?.role || "CD VP";
    const countries =
      userDetails?.countryCode
        ? userDetails.countryCode.toLowerCase().split(",")
        : [];
    userDetails.dtAccessCodes
      ? updateDTAccess(userDetails.dtAccessCodes.split(","))
      : updateDTAccess([]);
    if (bsa.length > 0) {
      const sortedArray = sortArray(bsa);
      userDetails.bsa = sortedArray;
      updateSelectedBsa(sortedArray[0]);
    }
    if (role !== "") {
      if(selectedCountryCode === "bd") {
        updateLevel(getLevelsBD(role));
      }
       else if (selectedCountryCode === "id") {
        updateLevel(getLevelsID(role));
      } else {
        updateLevel(getLevels(role));
      }
    }
    countryFunction(countries);
    if (
      countries.length > 0 &&
      !countries.includes(selectedCountryCode)
    ){
      updateCountryCode(countries[0]);
      localStorage.setItem("countryCode", countries[0]);
    }
    updateAdminAccess(userDetails?.userType == "CH");
    updateUcubeAccess(userDetails?.accessToUcube === "YES");
    updateOpsReportAccess(userDetails?.accessToOperationalDashboards === "YES");
  }, [updateDTAccess, updateLevel, updateSelectedBsa, userDetails, updateAdminAccess, updateUcubeAccess, updateOpsReportAccess]);

  return (
    <StoreContext.Provider value={value}>
      {props.children}
    </StoreContext.Provider>
  );
};

const mapStateToProps = state => {
  return {
    userDetails: state.store.userDetails,
    selectedBsa: state.store.selectedBsa,
    level: state.store.level,
    selectedCountryCode: state.store.selectedCountryCode,
    dtAccess: state.store.dtAccess,
    adminAccess: state.store.adminAccess,
    ucubeAccess: state.store.ucubeAccess,
    opsReportAccess: state.store.opsReportAccess,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateUserDetails(data) {
      dispatch(updateUserDetailsAction(data));
    },
    updateSelectedBsa(data) {
      dispatch(updateSelectedBsaAction(data));
    },
    updateLevel(data) {
      dispatch(updateLevelAction(data));
    },
    updateCountryCode(data) {
      dispatch(updateSelectedCountryCodeAction(data));
    },
    updateDTAccess(data) {
      dispatch(updateDTAccessAction(data));
    },
    updateAdminAccess(data) {
      dispatch(updateAdminAccessAction(data));
    },
    updateUcubeAccess(data) {
      dispatch(updateUcubeAccessAction(data));
    },
    updateOpsReportAccess(data) {
      dispatch(updateOpsReportAccessAction(data));
    }
  };
};

StoreContextProvider = connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreContextProvider);
StoreContextProvider.propTypes = {
  userDetails: PropTypes.shape({
    bsa: PropTypes.arrayOf(PropTypes.string),
    role: PropTypes.string,
    countryCode: PropTypes.string,
    dtAccessCodes: PropTypes.string,
    userType: PropTypes.string,
    accessToUcube: PropTypes.string,
    accessToOperationalDashboards: PropTypes.string
  }),
  updateUserDetails: PropTypes.func,
  updateSelectedBsa: PropTypes.func,
  selectedBsa: PropTypes.string,
  updateCountryCode: PropTypes.func,
  selectedCountryCode: PropTypes.string,
  updateLevel: PropTypes.func,
  level: PropTypes.arrayOf(PropTypes.string),
  dtAccess: PropTypes.arrayOf(PropTypes.string),
  updateDTAccess: PropTypes.func,
  updateAdminAccess: PropTypes.func,
  adminAccess: PropTypes.string,
  updateUcubeAccess: PropTypes.func,
  ucubeAccess: PropTypes.string,
  updateOpsReportAccess: PropTypes.func,
  opsReportAccess: PropTypes.string,
  children: PropTypes.node,
};

export { StoreContext, StoreContextProvider };

